module.exports = __WEBPACK_EXTERNAL_MODULE_87__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 87
// module chunks = 0